export default __webpack_public_path__ + "static/media/earth.8d915763.jpg";